import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
console.log("My App URL",BASE_URL);

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include the token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('jwtToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error && error.response && error.response.status === 401) {
    window.location.href = '/login'
  }
  return Promise.reject(error);
});

export default api;
